import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import { FUEL_TYPES } from '../constants/carFilters';
import EnableNotifications from './EnableNotifications';
import { card, inputStyle, btnStyle, labelStyle } from './EndUserShell';

const EMPTY = { model: '', minPrice: '', maxPrice: '', minYear: '', maxYear: '', minMileage: '', maxMileage: '', fuelTypes: [], active: false, damageNotifications: false, firstOwnerNotifications: false };

// Zavihek "Obvestila" — vklop web-push + testno obvestilo + osebni filter.
export default function EndUserHome() {
  const [form, setForm] = useState(EMPTY);
  const [saved, setSaved] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(true);
  const [testMsg, setTestMsg] = useState('');

  useEffect(() => {
    apiService.getUserFilter()
      .then((r) => {
        const d = r.data || {};
        setForm({
          model: d.model || '',
          minPrice: d.minPrice != null ? String(d.minPrice) : '',
          maxPrice: d.maxPrice != null ? String(d.maxPrice) : '',
          minYear: d.minYear != null ? String(d.minYear) : '',
          maxYear: d.maxYear != null ? String(d.maxYear) : '',
          minMileage: d.minMileage != null ? String(d.minMileage) : '',
          maxMileage: d.maxMileage != null ? String(d.maxMileage) : '',
          fuelTypes: d.fuelTypes || [],
          active: d.active || false,
          damageNotifications: d.damageNotifications || false,
          firstOwnerNotifications: d.firstOwnerNotifications || false,
        });
      })
      .catch(() => {})
      .finally(() => setLoadingFilter(false));
  }, []);

  const num = (v) => { const n = parseInt(v, 10); return isNaN(n) ? null : n; };

  const save = async (activeOverride, damageOverride, firstOwnerOverride) => {
    const active = activeOverride != null ? activeOverride : form.active;
    const damageNotifications = damageOverride != null ? damageOverride : form.damageNotifications;
    const firstOwnerNotifications = firstOwnerOverride != null ? firstOwnerOverride : form.firstOwnerNotifications;
    const dto = {
      model: form.model.trim() || null,
      minPrice: num(form.minPrice), maxPrice: num(form.maxPrice),
      minYear: num(form.minYear), maxYear: num(form.maxYear),
      minMileage: num(form.minMileage), maxMileage: num(form.maxMileage),
      fuelTypes: form.fuelTypes.length ? form.fuelTypes : null,
      bodyTypes: null, sellerTypes: null, brands: null, ageTypes: null,
      active, damageNotifications, firstOwnerNotifications,
    };
    try {
      await apiService.updateUserFilter(dto);
      setForm((f) => ({ ...f, active, damageNotifications, firstOwnerNotifications }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (e) {
      alert('Napaka pri shranjevanju filtra.');
    }
  };

  const toggleFuel = (code) => setForm((f) => ({
    ...f,
    fuelTypes: f.fuelTypes.includes(code) ? f.fuelTypes.filter((x) => x !== code) : [...f.fuelTypes, code],
  }));

  const sendTest = async () => {
    setTestMsg('Pošiljam…');
    try {
      const { data } = await apiService.testWebPush();
      setTestMsg(data.sent > 0 ? `Poslano ✓ (${data.sent})` : 'Ni aktivnih naročnin — najprej "Vklopi obvestila".');
    } catch (e) {
      setTestMsg('Napaka pri pošiljanju testa.');
    }
    setTimeout(() => setTestMsg(''), 5000);
  };

  if (loadingFilter) return <div style={card}>Nalagam…</div>;

  return (
    <>
      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <div>
            <div style={{ fontWeight: 600 }}>Obvestila</div>
            <div style={{ fontSize: 13, color: '#666' }}>Prejmi obvestilo, ko se pojavi avto po tvojem filtru.</div>
          </div>
          <EnableNotifications />
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12, fontSize: 14 }}>
          <input type="checkbox" checked={form.active} onChange={(e) => save(e.target.checked)} />
          Aktiviraj obvestila za ta filter
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, fontSize: 14 }}>
          <input type="checkbox" checked={form.damageNotifications} onChange={(e) => save(null, e.target.checked)} />
          Obveščaj me tudi o poškodovanih vozilih (V okvari)
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, fontSize: 14 }}>
          <input type="checkbox" checked={form.firstOwnerNotifications} onChange={(e) => save(null, null, e.target.checked)} />
          Obveščaj me tudi o vozilih "1. lastnik" (do 100.000 km, 1 lastnik, SLO)
        </label>
        <div style={{ marginTop: 10 }}>
          <button type="button" onClick={sendTest} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #0066cc', background: '#fff', color: '#0066cc', cursor: 'pointer' }}>
            Pošlji testno obvestilo
          </button>
          {testMsg && <span style={{ marginLeft: 10, fontSize: 13, color: '#555' }}>{testMsg}</span>}
        </div>
      </div>

      <div style={card}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Moj filter</div>
        <div style={labelStyle}>Model</div>
        <input style={inputStyle} value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} placeholder="npr. Golf, Passat…" />

        <Row label="Cena (€)">
          <Half v={form.minPrice} set={(v) => setForm({ ...form, minPrice: v })} ph="od" />
          <Half v={form.maxPrice} set={(v) => setForm({ ...form, maxPrice: v })} ph="do" />
        </Row>
        <Row label="Letnik">
          <Half v={form.minYear} set={(v) => setForm({ ...form, minYear: v })} ph="od" />
          <Half v={form.maxYear} set={(v) => setForm({ ...form, maxYear: v })} ph="do" />
        </Row>
        <Row label="Prevoženi km">
          <Half v={form.minMileage} set={(v) => setForm({ ...form, minMileage: v })} ph="od" />
          <Half v={form.maxMileage} set={(v) => setForm({ ...form, maxMileage: v })} ph="do" />
        </Row>

        <div style={labelStyle}>Gorivo</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
          {Object.entries(FUEL_TYPES).map(([code, name]) => {
            const on = form.fuelTypes.includes(code);
            return (
              <button type="button" key={code} onClick={() => toggleFuel(code)}
                style={{ padding: '6px 12px', borderRadius: 16, border: '1px solid #ddd', background: on ? '#0066cc' : '#fff', color: on ? '#fff' : '#333', cursor: 'pointer' }}>
                {name}
              </button>
            );
          })}
        </div>

        <button style={btnStyle} onClick={() => save()}>Shrani filter</button>
        {saved && <div style={{ color: '#0a0', textAlign: 'center', marginTop: 8 }}>✓ Shranjeno</div>}
      </div>
    </>
  );
}

function Row({ label, children }) {
  return (
    <div>
      <div style={labelStyle}>{label}</div>
      <div style={{ display: 'flex', gap: 8 }}>{children}</div>
    </div>
  );
}

function Half({ v, set, ph }) {
  return <input type="number" value={v} onChange={(e) => set(e.target.value)} placeholder={ph} style={inputStyle} />;
}
